var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNepalTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.711 76.1835L180.836 472.704L203.987 470.705L202.722 76.1631L185.711 76.1835Z",
    fill: "#F0FFF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2996_3108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 69,
    width: 37,
    height: 404
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173 69.3604H209.552V472.999H173V69.3604Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2996_3108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.641 74.6024L179.766 471.123L202.916 469.124L201.652 74.582L184.641 74.6024Z",
    stroke: "#F0FFF1",
    strokeWidth: 5.64389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2996_3108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 37,
    width: 42,
    height: 47
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173 37H214.773V83.7298H173V37Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2996_3108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.801 60.1935C211.229 70.3716 201.765 80.2642 191.342 78.7344C181.409 77.5514 174.311 67.0673 176.085 57.3787C177.105 48.4243 185.447 40.6326 194.647 41.6117C204.009 42.2236 210.964 51.0555 210.801 60.1935Z",
    fill: "#F0FFF1",
    stroke: "#F0FFF1",
    strokeWidth: 5.64389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2996_3108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 69,
    width: 178,
    height: 220
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.867 69.1436H380.098V288.454H203.867V69.1436Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2996_3108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.25 84.1966L350.869 170.028H244.05L355.336 280.091H212.25V84.1966ZM203.867 69.1436V288.454H375.591L264.324 178.329H380.098L203.867 69.1436Z",
    fill: "#F0FFF1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.062 76.6709V284.293H365.426L254.18 174.19H365.426L208.062 76.6709Z",
    fill: "#F0FFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.4 168.621C264.717 168.621 278.751 154.71 278.751 137.658C275.916 144.675 271.224 150.141 264.677 154.057L262.005 152.058L267.267 148.101L260.903 146.531L264.248 140.942L257.721 141.819L258.68 135.374L252.989 138.698L251.378 132.416L247.4 137.617L243.464 132.416L241.852 138.698L236.161 135.374L237.079 141.819L230.573 140.942L233.918 146.531L227.534 148.101L232.837 152.058L230.124 154.057C223.576 150.162 218.885 144.695 216.07 137.658C216.091 154.71 230.104 168.621 247.4 168.621Z",
    fill: "#231942"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.075 234.687L281.089 229.221L268.075 223.754L276.601 212.556L262.527 214.29L264.261 200.379L252.961 208.824L247.413 195.933L241.906 208.824L230.585 200.379L232.299 214.29L218.266 212.556L226.792 223.754L213.758 229.221L226.792 234.687L218.266 245.885L232.299 244.172L230.585 258.083L241.906 249.597L247.413 262.55L252.961 249.597L264.261 258.083L262.527 244.172L276.601 245.885L268.075 234.687Z",
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepalTransfer);
export default __webpack_public_path__ + "static/media/nepal_transfer.177c9a25e156076d7c92cda81428cd4c.svg";
export { ForwardRef as ReactComponent };